import { render, staticRenderFns } from "./person_schedule_approval.vue?vue&type=template&id=618b5cfd&"
import script from "./person_schedule_approval.vue?vue&type=script&lang=js&"
export * from "./person_schedule_approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618b5cfd')) {
      api.createRecord('618b5cfd', component.options)
    } else {
      api.reload('618b5cfd', component.options)
    }
    module.hot.accept("./person_schedule_approval.vue?vue&type=template&id=618b5cfd&", function () {
      api.rerender('618b5cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_schedule_approval.vue"
export default component.exports